import { configureStore } from '@reduxjs/toolkit';

import accountPositionsReducer from 'Reducers/accountPositions';
import accountRelationshipsReducer from 'Reducers/accountRelationships';
import accountsReducer from 'Reducers/accounts';
import accountsWithdrawalRelationshipsReducer from 'Reducers/accountsWithdrawalRelationships';
import accountWithdrawalDataReducer from 'Reducers/accountWithdrawalData';
import addressBookReducer from 'Reducers/addressbook';
import apiConnectionReducer from 'Reducers/apiconnections';
import apiConnectionUserReducer from 'Reducers/apiconnectionusers';
import assetReducer from 'Reducers/assets';
import clientMessageReducer from 'Reducers/clientMessage';
import feeReducer from 'Reducers/fees';
import firmAssetEntitlementsReducer from 'Reducers/firmAssetEntitlements';
import firmReducer from 'Reducers/firms';
import killSwitchReducer from 'Reducers/kllSwitch';
import netAssetValuesReducer from 'Reducers/netAssetValues';
import pledgesReducer from 'Reducers/pledges';
import pricesReducer from 'Reducers/prices';
import transactionsReducer from 'Reducers/transactions';
import uiReducer from 'Reducers/ui';
import userReducer from 'Reducers/user';
import userAccountReducer from 'Reducers/userAccounts';
import userApiTypeReducer from 'Reducers/userApiTypes';
import usersReducer from 'Reducers/users';
import validationReducer from 'Reducers/validation';

const clientStore = configureStore({
    devTools: { name: 'Tassat - Client' },
    reducer: {
        accounts: accountsReducer,
        accountPositions: accountPositionsReducer,
        accountRelationships: accountRelationshipsReducer,
        accountsWithdrawalRelationships: accountsWithdrawalRelationshipsReducer,
        accountsWithdrawalData: accountWithdrawalDataReducer,
        addressBook: addressBookReducer,
        apiConnections: apiConnectionReducer,
        apiConnectionUsers: apiConnectionUserReducer,
        firms: firmReducer,
        firmAssetEntitlements: firmAssetEntitlementsReducer,
        killSwitch: killSwitchReducer,
        transactions: transactionsReducer,
        ui: uiReducer,
        user: userReducer,
        users: usersReducer,
        userAccounts: userAccountReducer,
        userApiTypes: userApiTypeReducer,
        validation: validationReducer,
        clientMessage: clientMessageReducer,
        assets: assetReducer,
        netAssetValues: netAssetValuesReducer,
        prices: pricesReducer,
        pledges: pledgesReducer,
        fees: feeReducer
    }
});

export type ClientState = ReturnType<typeof clientStore.getState>;
export type ClientDispatch = typeof clientStore.dispatch;

export default clientStore;